import { parse as _parse, prop as _prop } from "./template-parser";
export const parse = _parse;
export const prop = _prop;
